var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3780 4793 c-38 -16 -74 -50 -91 -87 -16 -35 -19 -67 -19 -203 l0 -163 -163 0 c-149 0 -167 -2 -207 -22 -61 -31 -92 -86 -87 -151 5 -54 27 -91 77 -124 31 -22 43 -23 206 -23 l172 0 4 -179 c3 -164 5 -182 24 -208 56 -76 154 -97 225 -49 61 42 69 71 69 265 l0 171 171 0 c194 0 223 8 265 69 48 71 27 169 -49 225 -26 19 -44 21 -208 24 l-179 4 0 172 c0 163 -1 175 -22 206 -35 50 -71 72 -125 76 -26 2 -55 1 -63 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382 4639 c-275 -32 -540 -234 -651 -495 -65 -155 -62 -52 -59 -1839 l3 -1620 37 -78 c120 -251 420 -358 661 -236 23 12 251 168 507 347 255 179 484 338 509 354 47 30 106 37 154 19 14 -6 244 -163 512 -351 268 -188 508 -352 534 -366 143 -71 291 -71 439 2 129 63 232 196 261 336 8 37 11 427 9 1290 l-3 1237 -21 28 c-73 98 -195 98 -268 0 -21 -28 -21 -30 -26 -1270 -4 -947 -8 -1247 -17 -1263 -37 -65 -117 -103 -188 -90 -23 5 -202 124 -532 355 -274 192 -520 360 -548 373 -27 14 -74 31 -104 38 -74 17 -211 8 -282 -19 -37 -14 -237 -148 -570 -381 -316 -221 -527 -362 -547 -366 -71 -14 -150 23 -183 86 -18 33 -19 96 -19 1606 0 1540 0 1573 20 1636 56 183 223 323 411 348 41 5 386 10 767 10 763 0 726 -3 775 62 14 18 28 47 32 65 15 75 -44 166 -121 184 -49 11 -1393 9 -1492 -2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.6c7b000891c879a460d1465a350f8a94.svg";
export { ForwardRef as ReactComponent };